module.exports = __webpack_public_path__ + "static/img/womanonstairs-long.d1e0d8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/womanonstairs-long.png
// module id = 871
// module chunks = 0